const localizeDate = (utcDate?: string | null): string =>
    !utcDate ? '---' : new Date(`${utcDate}${!utcDate.endsWith('Z') ? 'Z' : ''}`).toLocaleString('sv-SE')

export default localizeDate
